/**
 * 营运中心--》分担配载
 */

 export default {
  // 分担配载-新增是否配载完成时传入 选择车牌号时下发的其他信息（身份证号：sjsfz 司机住址：sjaddress	驾驶证号：sjjsz	发动机号：CPUNO	）且回填驾驶证号
  save_fdpz_add_car_driver_other_info: ['96023'], // 202505161511450531720
  // 分单配载右侧表格 实发重量、实发体积编辑时支持的小数位数是否保持和 重量、体积一致 （公版目前默认是2，不满足部分定制了重量、体积最大位数超过2的用户）

  // https://imagecdn.ymm56.com/ymmfile/static/resource/ac467fad-dd67-476e-a529-09fad8bcfaf5.png
  fdpz_use_weight_volume_precision: ['75586', '73971', '76059', '80806', '77162', '84139', '80363', '96767', '99018'], // 202507311349453673953、202508081648238501106

  // 分单配载-校验运单上至少有3张图片,不满足不可以进行配载
  // https://imagecdn.ymm56.com/ymmfile/static/resource/5da91e46-3e1e-47b8-8c0b-261692089763.jpg
  check_piccount_in_fdpz: ['97837'], // 202508151458304933213
  //https://imagecdn.ymm56.com/ymmfile/static/resource/398beb69-a474-4bf3-852f-c829a725441b.png
  bigCar_fee_reduce: ['99139'],// 202508311552311236494 99139 定制大车费减款
  // 202509051247290736067 
  tonnage_input: ['84139'], // 新增 吨位输入框
  unitPrice_input: ['84139'],// 新增 单价输入框
  taxrate_input: ['84139'], // 新增 税率下拉框
  taxes_input: ['84139'], // 新增 税金输入框
  ywy_input: ['84139'], // 新增 业务员输入框
  taxes_calculate: ['84139'], // 新增 税金计算逻辑
  disabled_field_accback_by_power: ['84139'], // 权限控制只读字段 回付司机
  disabled_field_updown_by_power: ['84139'], // 权限控制只读字段 本车装卸费
  acctotal_rule: ['84139'], // 运费合计并等于原运费合计+本车其他费+本车装卸费
  operating_range_can_edit: ['97707','97757','97992','99505'], // 202510101337298433238 分单配载 运行区间到站可编辑
  // 分单配载-本车清单新增批量打印
  print_batch_car_list: ['93052', '82635'], // 202509161519117676855
  boat_note_submit:['84030'], // 202511041341524638260 配载清单保存时客户名称必填
  show_operation_buttons_top: ['83224'], // 202511060938551475676 分单配载展示操作按钮顶部
  open_disabled_field_bus_fare:['99139'], // 202509281756376232927 定制大车费禁用逻辑放开可编辑
  // 开启正确的排序，未开启的时候某些情况会在排序时直接调用reverse，reverse在左右挑单后新增数据后会有问题
  fdpz_use_nocache_sort: ['99690'], // 202511121552525902312
  // 分担配载中装车配载新增核定重量和核定体积
  fdpz_loading_stowage_verified:['73587'], // 202512031259340807653
  // 货物位置枚举拓展
  fdpz_extend_stowage_verified_position:['96206'], // 202601131002096776180
  // 货车类型新增整车和零担
  fdpz_add_vehicle_type: ['60993'], // 202602251110173831361
  // 分单配载-添加勾选框
  fdpz_add_checkbox: ['86823', '91836', '82635', '93821', '90100', '97993',"60773"], 
  // 分单配载-运费公式定制
  fdpz_acctotal_rule: ['84134'], //84134-202603191001598708941运费合计=现付司机+回付司机+到付司机+油卡付+油卡押金+本车装卸费+本车接货费+本车其他费
}
